<template>
  <article
    class="notification | bg-white rounded-lg | p-16 | flow"
    data-type="comment"
    @click="router.push(notification.location.dialoguri + '&comments=true')"
  >
    <header>
      <p class="flex">
        <strong
          class="notification__type | font-medium text-primary"
          data-icon="comment"
          >Réponse à
          {{
            notification.location.parent.author.name
              ? notification.location.parent.author.name
              : notification.location.parent.author.email
          }}</strong
        >
        <span class="notification__client | text-grey-700">{{
          notification.project.title
        }}</span>
        <time
          datetime=""
          class="notification__date | text-grey-700 | ml-auto"
          >{{ formatDate(notification) }}</time
        >
      </p>
    </header>
    <p
      v-if="notification.type"
      class="notification__body | text-md font-medium | line-clamp"
    >
      {{
        notification.author.name
          ? notification.author.name
          : notification.author.email
      }}
      : {{ notification.text }}
    </p>
  </article>
</template>

<script setup>
import { useRouter } from "vue-router";
import { useNotificationsStore } from "../../stores/notifications";

const router = useRouter();
const { notification } = defineProps({ notification: Object });
const { formatDate } = useNotificationsStore();
</script>
